<script setup lang="ts">
import { computed } from 'vue';
import { ItemName } from '../_shared';
import { getItemIcon } from './get-file-icon';
import { ICON_PIXEL_SIZES } from '@/components/document/sub-components/file-manager/views/file-explorer-view/iconSize';
import type { FileExplorerIconSize } from '@/components/document/sub-components/file-manager/logic/core/useFileManagerSettings';
import type { FileItem } from '@/components/document/sub-components/file-manager/types';

const props = defineProps<{
  item: FileItem;
  iconSize: FileExplorerIconSize;
  // Optional display label passed straight through to ItemName; the icon still derives from the
  // real item.name (which keeps its extension).
  displayName?: string;
}>();

const fileIcon = computed(() => getItemIcon(props.item));
const pixelSize = computed(() => ICON_PIXEL_SIZES[props.iconSize]);
</script>

<template>
  <component
    :is="fileIcon.icon"
    :size="pixelSize"
    weight="fill"
    :color="fileIcon.color"
  />
  <ItemName :name="item.name" :display-name="displayName" :icon-size="iconSize" />
</template>
